import { useState } from 'react';
import styles from './ForgotPassword.module.css';
import toneLogo from '../../assests/images/tone-logo.png';
import { useDispatch } from 'react-redux';
import { forgotPasswordTrigger } from '../../slices/authSlice';
import { AppDispatch } from '../../store';
import image4 from '../../assests/images/Image 4.png';
import image5 from '../../assests/images/Image 5.png';
import { ForgotPasswordFormInputs } from '../../dtos/auth';
import { NavLink } from 'react-router-dom';
import Form from '../Layout/Form';

const ForgotPassword = () => {
  const dispatch = useDispatch<AppDispatch>();
  
  const [formData, setFormData] = useState<ForgotPasswordFormInputs>({
    email: ''
  });
  const [formErrors, setFormErrors] = useState<Record<string, string>>({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleFormFieldChange = (fieldName: string, value: any) => {
    setFormData(prev => ({
      ...prev,
      [fieldName]: value
    }));
    
    // Clear validation error for this field
    if (formErrors[fieldName]) {
      setFormErrors(prev => {
        const { [fieldName]: removed, ...rest } = prev;
        return rest;
      });
    }
  };

  const onSubmit = async (data: Record<string, any>) => {
    // Validate form data
    const errors: Record<string, string> = {};
    if (!data.email || data.email.trim() === '') {
      errors.email = 'Email is required';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email)) {
      errors.email = 'Invalid email address';
    }

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }

    setIsSubmitting(true);
    const toastId = console.log('Info: ', 'Processing...');
    
    try {
      const response = await dispatch(forgotPasswordTrigger(data.email)).unwrap();
      // toast.dismiss(toastId);

      console.log('Success: ', response.message);
    } catch (error) {
      // toast.dismiss(toastId);
      console.log('Error: ', 'An error occurred while processing your request');
    } finally {
      setIsSubmitting(false);
    }
  };

  // Form schema
  const formSchema = [
    {
      name: 'email',
      type: 'email' as const,
      label: 'Email',
      required: true,
      placeholder: 'Enter your email'
    }
  ];

  return (
    <div className={styles.page}>
      <div className={styles.backgroundLeft}>
        <img src={image4} alt="image54" />
      </div>
      <div className={styles.backgroundRight}>
        <img src={image5} alt="image5" />
      </div>
      <div className={styles.container}>
        <img src={toneLogo} alt="Logo" className={styles.logo} />
        <div className={styles.formContainer}>
          <h3 className={styles.title}>Reset Password </h3>
          
          <Form
            schema={formSchema}
            initialData={formData}
            onSubmit={onSubmit}
            onFieldChange={handleFormFieldChange}
            validationErrors={formErrors}
            isLoading={isSubmitting}
            submitButtonText="Send Mail"
            submitButtonProps={{
              className: styles.submitButton
            }}
            className={styles.form}
          />
          
          <hr />
          <NavLink
            to="/login"
            className={styles.backLink}
          >
            Back to Login
          </NavLink>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
